import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useRouter from '../hook/useRouter';
import { IPriceItemList } from '../interface/IPrice';
import { RootState } from '../store';
import { PriceItem } from './PriceItem';

import { Tooltip } from 'react-tooltip';
import { ISearchParam } from '../interface/ICommon';

export const PriceList = ({
    listData,
    priceListParam,
    loading,
    firstSvrId,
}: {
    listData: IPriceItemList['contents'] | undefined;
    priceListParam: ISearchParam;
    loading: boolean;
    firstSvrId: string;
}) => {
    const l10n = useSelector((state: RootState) => state.main.l10n);

    const [svrid, svridSet] = useState('');
    const [sale, saleSet] = useState('');
    const [favor, favorSet] = useState('');
    const [bless, blessSet] = useState('');
    const [page, pageSet] = useState('');
    const [query, querySet] = useState('');

    const { params, getValue, changeParam } = useRouter(['serverid', 'sale', 'favorite', 'bless', 'page', 'query']);
    useEffect(() => {
        if (!params) return;

        let svr_id = getValue('serverid');
        if (svr_id === '') svr_id = firstSvrId || 'all';

        svridSet(svr_id);
        saleSet(getValue('sale'));
        favorSet(getValue('favorite'));
        blessSet(getValue('bless'));
        pageSet(getValue('page'));
        querySet(getValue('query'));
    }, [params]);

    if (!listData) {
        return null;
    }

    const setNoResultandFavs = () => {
        let result;

        if (sale === 'false' && favor !== 'true') {
            result = l10n['common.noresultsitemprice'].toString();
        } else if (sale !== 'false' && favor !== 'true') {
            result = l10n['price.noteresultsitemprice'].toString();
        } else if (favor === 'true') {
            result = l10n['common.noresultsfavs'].toString();
        } else {
            result = '';
        }

        return { __html: result };
    };

    return (
        <section className="gameinfo-result__list">
            {loading && (
                <div className="gameinfo-loader is-show">
                    <span className="loader"></span>
                </div>
            )}

            {listData.length < 1 && (
                <div className="nodata" style={{ display: 'block' }} dangerouslySetInnerHTML={setNoResultandFavs()}></div>
            )}

            <div
                className={`ui-table ${svrid === 'all' ? 'allserver' : 'selectedserver'}`}
                data-tabletype="itemprice"
                style={{ display: listData.length < 1 ? 'none' : 'block' }}
            >
                <div className="tablehead">
                    <div className="tablerow">
                        <div className="tablecell favorite"></div>
                        <div className="tablecell itemname">{l10n['common.itemname']}</div>
                        {svrid === 'all' ? (
                            <>
                                <div className="tablecell server">{l10n['noti.server']}</div>
                                <div className="tablecell min-price">
                                    {l10n['noti.lowestprice']}
                                    <button className="ico-q" data-tooltip-id="my-tooltip"></button>
                                    <Tooltip id="my-tooltip">{l10n['common.tooltiptheaditemprice1']}</Tooltip>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="tablecell min-price">
                                    {l10n['noti.lowestprice']}
                                    <button className="ico-q" data-tooltip-id="my-tooltip2"></button>
                                    <Tooltip id="my-tooltip2">{l10n['common.tooltiptheaditemprice1']}</Tooltip>
                                </div>
                                <div className="tablecell avg-price">
                                    {l10n['common.avgprice']}
                                    <button className="ico-q" data-tooltip-id="my-tooltip3"></button>
                                    <Tooltip id="my-tooltip3">{l10n['common.tooltiptheaditemprice2']}</Tooltip>
                                </div>
                            </>
                        )}
                        <div className="tablecell qty">{l10n['common.listitems']}</div>
                    </div>
                </div>
                <div className="tablebody">
                    {listData.map((it, idx) => (
                        <PriceItem
                            key={
                                idx +
                                it.itemId +
                                it.favorite.toString() +
                                it.enchantLevel +
                                it.quantity +
                                it.grade +
                                it.serverId +
                                bless +
                                page +
                                query
                            }
                            it={it}
                            svrid={svrid}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};
